<template>
<div class="container">
  <h1>ギャラリー</h1>
  <b-container fluid class="p-4">
    <b-row>
      <b-col sm="6" v-for="schedule in data" :key="schedule.ID">
        <b-card :title="schedule.Target.DisplayName"
                :img-src="makeImageURL(schedule)"
                :img-alt="schedule.Target.DisplayName"
                img-top
        >
          <div class="card-text">
            <dl>
              <dt>予約日時</dt>
              <dd :title="'JDN:' + schedule.Time.JDN">{{ schedule.Time.Start }}</dd>
              <dt>撮影枚数</dt>
              <dd>{{ schedule.Exposure[0].Repeat }}</dd>
              <dt>露出時間</dt>
              <dd>{{ schedule.Exposure[0].Time.inverse ? "1 / " : "" }}{{ schedule.Exposure[0].Time.n }}</dd>
              <dt>ISO</dt>
              <dd>{{ schedule.Exposure[0].ISO }}</dd>
            </dl>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</div>
</template>

<script>
import axios from 'axios'
import firebase from 'firebase'

export default {
  name: 'information',
  data() {
    return {
      data: [],
      session: this.$store.state.loginUser.session,
      noimage: "<svg width=\"300\" height=\"200\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 300 200\" preserveAspectRatio=\"none\"><defs><style type=\"text/css\">%23noimage text { fill:rgba(255,255,255,.75);font-weight:normal;font-family:Helvetica, monospace;font-size:10pt } </style></defs><g id=\"noimage\"><rect width=\"300\" height=\"200\" fill=\"%23777\"></rect><g><text x=\"123.640625\" y=\"104.5\">No Image</text></g></g></svg>",
    }
  },
  created() {
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        this.reloadGallery();
      }
    });
  },
  methods: {
    reloadGallery() {
      if (this.session.user) {
        this.session.user.getIdToken(true).then((idToken) => {
          axios.get(this.$store.state.config.API_ROOT + "/gallery/list", {
            headers: {
              "Authorization": "Bearer " + idToken
            }
          }).then((response) => {
            this.data = response.data;
          });
        });
      }
    },
    makeImageURL(schedule) {
      if ( ! schedule.Images ) {
        // not yet uploaded
        return "data:image/svg+xml;charset=UTF-8," + this.noimage;
      }
      // get first image (probably random pick)
      for (let key in schedule.Images) {
        if ( ! schedule.Images[key] ) {
          continue;
        }
        return this.$store.state.config.STORAGE_ROOT + `thumb%2F${schedule.Telescope.Telescope}%2F${schedule.ID}%2F${key}?alt=media`;
      }
      // all images deleted
      return "data:image/svg+xml,charset=UTF-8," + this.noimage;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Gallery.vue